import Select from "components/shared/select";
import { ymEvent } from "helpers/system";
import moment from "moment";
import React, { useState } from "react";

const SelectPeriod = (props) => {
    const [period, setPeriod] = useState(props.period);

    const minYear = 2025;
    const minMonth = 7;

    const currentYear = moment().year();
    const currentMonth = moment().format("MM");

    const monthsOptions = [
        { label: "Январь", value: "01" },
        { label: "Февраль", value: "02" },
        { label: "Март", value: "03" },
        { label: "Апрель", value: "04" },
        { label: "Май", value: "05" },
        { label: "Июнь", value: "06" },
        { label: "Июль", value: "07" },
        { label: "Август", value: "08" },
        { label: "Сентябрь", value: "09" },
        { label: "Октябрь", value: "10" },
        { label: "Ноябрь", value: "11" },
        { label: "Декабрь", value: "12" },
    ];

    const getOptionsByName = (name) => {
        switch (name) {
            case "month": {
                return currentYear === minYear
                    ? monthsOptions.slice(parseInt(minMonth) - 1, parseInt(currentMonth))
                    : period.year === minYear
                      ? monthsOptions.splice(parseInt(minMonth) - 1, monthsOptions.length)
                      : period.year === currentYear
                        ? monthsOptions.splice(0, parseInt(currentMonth))
                        : monthsOptions;
            }
            case "year": {
                const yearOptions = [];

                let i = minYear;

                while (i <= currentYear) {
                    yearOptions.push({ label: i.toString(), value: i });

                    i++;
                }

                return yearOptions;
            }
        }
    };

    const onChange = ({ name, value }) => {
        const newPeriod = { ...period };
        if (name === "year") {
            value === minYear && parseInt(newPeriod.month) < parseInt(minMonth) && (newPeriod.month = minMonth);
            value === currentYear &&
                parseInt(newPeriod.month) > parseInt(currentMonth) &&
                (newPeriod.month = currentMonth);
        }

        setPeriod({ ...newPeriod, [name]: value });
    };

    const getConfigByPropName = (name) => ({
        inputProps: { name },
        options: getOptionsByName(name),
        value: period[name],
        onChange,
        styles: {
            container: (styles) => ({ ...styles, minWidth: "150px" }),
        },
    });

    const handleUpdatePeriod = () => {
        if (!period.year || !period.month) {
            return;
        }
        ymEvent("UpdateDriversReport");
        props.setPeriod(period);
        props.refetch();
    };

    return (
        <div className="d-flex align-items-center flex-wrap">
            <div className="mr-2">
                <Select {...getConfigByPropName("month")} />
            </div>
            <div className="mr-2">
                <Select {...getConfigByPropName("year")} />
            </div>
            <a className="btn btn-brand btn-sm" onClick={handleUpdatePeriod}>
                Обновить
            </a>
        </div>
    );
};

export default SelectPeriod;
